module.exports = __webpack_public_path__ + "static/media/HouseBuilding.4ee3dfbe.svg";